module.exports = ".brand{font-size:20px;line-height:26px;letter-spacing:.07em;font-weight:600;color:#fff}"